import { Typography } from '@/shared/ui/typography'

import { type FC } from 'react'
import { Lock, Unlock } from 'react-bootstrap-icons'
import { useTranslation } from 'react-i18next'

import { useSideMenuContext } from './context'

/**
 * Internal pin toggle, auto-rendered by SideMenu at the bottom of the rail.
 *
 * The button doesn't open or close the menu (hover preview already handles
 * temporary expansion) — it pins/unpins it. The icon reflects the current
 * state: closed padlock when pinned open, open padlock when free.
 *
 * Desktop only — hidden on mobile via CSS.
 */
export const SideMenuToggle: FC = () => {
  const { isOpen, setOpen, navId } = useSideMenuContext()
  const { t } = useTranslation()
  const label = isOpen ? t('sideMenu.aria.unpinMenu') : t('sideMenu.aria.pinMenu')

  return (
    <button
      type="button"
      className="side-menu-item hidden lg:flex"
      onClick={() => setOpen(!isOpen)}
      aria-label={label}
      aria-pressed={isOpen}
      aria-controls={navId}
    >
      <span className="side-menu-item-content">
        <span className="side-menu-item-icon">{isOpen ? <Unlock /> : <Lock />}</span>
        <span className="side-menu-item-label">
          <Typography type="paragraph" variant="md">
            {label}
          </Typography>
        </span>
      </span>
    </button>
  )
}

SideMenuToggle.displayName = 'SideMenuToggle'
